import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CalendarPicker } from '@pwc/appkit-react-datepicker';

import { FormikPropTypes } from '../propTypes';

const DatepickerFormik = ({
  formik,
  name,
  value,
  ...additionalProps
}) => {
  const handleChange = useCallback(value => {
    if (value[1]) {
      const [from, to] = value;
      formik.setFieldValue(name, { from, to });
    }
  }, [name, formik]);

  return (
    <CalendarPicker
      selectRange
      value={[value.from, value.to]}
      onChange={handleChange}
      {...additionalProps}
    />
  );
};

DatepickerFormik.propTypes = {
  formik: FormikPropTypes,
  name: PropTypes.string.isRequired,
  value: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }).isRequired,
};

export default DatepickerFormik;
